import FingerprintJS from '@fingerprintjs/fingerprintjs'

/**
 *
 * Fetches visitorId from @fingerprintjs/fingerprintjs
 * and returns it
 * @example
 * ```typescript
 * const deviceId = await getFingerprint()
 * ```
 */
const getFingerprint = async () => {
  const fingerprint = await FingerprintJS.load()
  const result = await fingerprint.get()

  const {visitorId: deviceId} = result

  return deviceId
}

export default getFingerprint
